/** Display name for BPL audit fields */
export function getBplUserName(profile, user) {
  if (profile?.display_name?.trim()) return profile.display_name.trim()
  if (profile?.full_name?.trim()) return profile.full_name.trim()
  if (user?.email) return user.email
  return 'User'
}
